import { useParams } from "react-router";
import StatsConsole from "./StatsConsole/Layout/StatsConsole";
import { useTheme } from "../stores/useTheme";
import { useContext, useEffect, useRef, useState } from "react";
import { getUrlParam } from "@ihs-widget/utils/functions";
import { T, UrlParams } from "@ihs-widget/utils/enums";
import { StateContext } from "../state/stateContext";

interface IStatsConsoleWrapper {
  item: string;
}

export type State = 'minimized' | 'standard' | "expanded";

export const StatsConsoleWrapper = ({ item }: IStatsConsoleWrapper) => {
  const { state } = useParams();
  const { theme, toggleTheme } = useTheme();
  const themeURL = getUrlParam(UrlParams.THEME);
  const isMVPURL = getUrlParam(UrlParams.IS_MVP);
  const statsConsoleWrapperRef = useRef<HTMLDivElement>(null);
  
  const ctx = useContext(StateContext);
  const { stContext, setStContext } = ctx || {};
  const [isMVP, setIsMVP] = useState(isMVPURL ? isMVPURL === 'true' : true);
  

  useEffect(() => {
    if (themeURL) {
      toggleTheme(themeURL);
    }
  }, [themeURL])

  useEffect(() => {
    setIsMVP(isMVPURL ? isMVPURL === 'true' : true);
  }, [isMVPURL])


  useEffect(() => {
    setStContext({ 
      ...stContext, 
      statsConsoleIframeWidth: statsConsoleWrapperRef.current?.clientWidth
    })
  }, [statsConsoleWrapperRef.current?.clientWidth])

  const stateDefaultVal: State = state ? state as State : 'minimized';


  return (
    <div ref={statsConsoleWrapperRef} className={`${theme === T.DARK ? T.DARK : ''}  `}>
      {item === 'StatsConsole' && <StatsConsole state={stateDefaultVal} isMVP={isMVP}/>}
    </div>
  );
};
